module.exports = __webpack_public_path__ + "media/icons/sun-d26646618c158ec888bb2ad9a982cfc4.svg";